import { gql } from "lib/apolloClient";

export const childFragmentForStaff = {
  basicChildDetails: gql`
    fragment childItem on Student {
      id
      email
      type
      profileImage
      inviteExpireTime
      firstName
      middleName
      lastName
      isDevUser
      parentStatus(parentId: $id)
      isRequestAccepted
      sourceId
      familyInviteCode
      signInCode
      preferredName
      prefix
      suffix
      pronouns
    }
  `,
};

export const parentFragment = {
  basicParentDetails: gql`
    fragment parentItem on FamilyMember {
      id
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      profileImage
      type
      Email: email
      isDevUser
      isCreatedByOrg
    }
  `,
};
